import { render, staticRenderFns } from "./CataloguesCardHeader.vue?vue&type=template&id=7fb55f8c&scoped=true"
import script from "./CataloguesCardHeader.vue?vue&type=script&lang=js"
export * from "./CataloguesCardHeader.vue?vue&type=script&lang=js"
import style0 from "./CataloguesCardHeader.vue?vue&type=style&index=0&id=7fb55f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb55f8c",
  null
  
)

export default component.exports